import React, { PureComponent } from 'react';
import { Col, Row } from 'reactstrap';
import SmallChart from '../chart/SmallChart';

export default class EngagementCharts extends PureComponent {
  render() {
    const {
      pageviews,
      pageviews_TREND,
      pageviews_TOTAL,
      users,
      users_TREND,
      users_TOTAL,
      sessionsPerUser,
      sessionsPerUser_TREND,
      sessionsPerUser_TOTAL,
      sessions,
      sessions_TREND,
      sessions_TOTAL,
      avgSessionDuration,
      avgSessionDuration_TREND,
      avgSessionDuration_TOTAL,
      pageviewsPerSession,
      pageviewsPerSession_TREND,
      pageviewsPerSession_TOTAL
    } = this.props;
    return (
      <div className="dashboard-container content-container engagement">
        <div className="dashboard-title">Engagement</div>
        <Row>
          <Col sm="6">
            <SmallChart
              data={users}
              trend={users_TREND}
              total={users_TOTAL}
              title="Users"
              className="with-border-radius"
            />
          </Col>
          <Col sm="6">
            <SmallChart
              data={pageviews}
              trend={pageviews_TREND}
              total={pageviews_TOTAL}
              title="Page views"
              className="with-border-radius"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="6">
            <SmallChart
              data={sessions}
              trend={sessions_TREND}
              total={sessions_TOTAL}
              title="Sessions"
            />
          </Col>
          <Col sm="6">
            <SmallChart
              type="bar"
              data={pageviewsPerSession}
              trend={pageviewsPerSession_TREND}
              total={pageviewsPerSession_TOTAL}
              title="Pages per session"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="6">
            <SmallChart
              type="bar"
              data={sessionsPerUser}
              trend={sessionsPerUser_TREND}
              total={sessionsPerUser_TOTAL}
              title="Sessions per user"
            />
          </Col>
          <Col sm="6">
            <SmallChart
              type="bar"
              data={avgSessionDuration}
              trend={avgSessionDuration_TREND}
              total={avgSessionDuration_TOTAL}
              title="Avg. Session duration"
            />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/EngagementCharts.js